import React from 'react';
import IndexSections from '../../components/ptgc/index/Index'; 

const IndexPage = () => {
  return (
    <>
      <IndexSections /> 
    </>
  );
};

export default IndexPage;